module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [(_vm.tableQuery.remind != 'remind') ? _c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.tableQuery.Xnxqbm),
      callback: function($$v) {
        _vm.$set(_vm.tableQuery, "Xnxqbm", $$v)
      },
      expression: "tableQuery.Xnxqbm"
    }
  }, _vm._l((_vm.xnxqQuery), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.tableQuery.remind != 'remind') ? _c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "所属系部",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeOption('dept')
      }
    },
    model: {
      value: (_vm.tableQuery.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.tableQuery, "deptCode", $$v)
      },
      expression: "tableQuery.deptCode"
    }
  }, _vm._l((_vm.queryCombo.dept), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.tableQuery.remind != 'remind') ? _c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "所属专业",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeOption()
      }
    },
    model: {
      value: (_vm.tableQuery.majorCode),
      callback: function($$v) {
        _vm.$set(_vm.tableQuery, "majorCode", $$v)
      },
      expression: "tableQuery.majorCode"
    }
  }, _vm._l((_vm.queryCombo.major), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.tableQuery.remind != 'remind') ? _c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "年级名称",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeOption()
      }
    },
    model: {
      value: (_vm.tableQuery.gradeCode),
      callback: function($$v) {
        _vm.$set(_vm.tableQuery, "gradeCode", $$v)
      },
      expression: "tableQuery.gradeCode"
    }
  }, _vm._l((_vm.queryCombo.grade), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.tableQuery.remind != 'remind') ? _c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "班级名称",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.tableQuery.classCode),
      callback: function($$v) {
        _vm.$set(_vm.tableQuery, "classCode", $$v)
      },
      expression: "tableQuery.classCode"
    }
  }, _vm._l((_vm.queryCombo.class), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.tableQuery.remind != 'remind') ? _c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.tableQuery.Xh),
      callback: function($$v) {
        _vm.$set(_vm.tableQuery, "Xh", $$v)
      },
      expression: "tableQuery.Xh"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableQuery.remind != 'remind') ? _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }, [_vm._v(" 查询")])]) : _vm._e(), _vm._v(" "), (_vm.tableQuery.remind != 'remind') ? _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]) : _vm._e(), _vm._v(" "), (_vm.tableQuery.remind != 'remind') ? _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.warnSet
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }, [_vm._v(" 学业预警设置")])]) : _vm._e(), _vm._v(" "), (_vm.tableQuery.remind != 'remind') ? _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.warnExport
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }, [_vm._v(" 批量导出")])]) : _vm._e(), _vm._v(" "), (_vm.tableQuery.remind != 'remind') ? _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.remind
    }
  }, [_c('i', {
    staticClass: "el-icon-bell"
  }, [_vm._v(" 发送提醒")])]) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.mainTableHeight,
      "header-cell-style": {
        'text-align': 'center',
        'background-color': '#F1FAF6'
      },
      "element-loading-text": "信息加载中",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.limit + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学年学期名称",
      "prop": "xnxqmc",
      "align": "center",
      "min-width": "20@%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "班级名称",
      "prop": "bjjc",
      "align": "center",
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学号",
      "prop": "xh",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "xm",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总课程数量",
      "prop": "zkcsl",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合格课程数量",
      "prop": "hgkcsl",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程学分",
      "prop": "xf",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "获得学分",
      "prop": "hdxf",
      "align": "center",
      "min-width": "10%"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.exportTitle,
      "top": "25vh",
      "visible": _vm.exportAllDialog,
      "before-close": _vm.handleEditDialogClose,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.exportAllDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "exportForm",
    staticClass: "small-space",
    staticStyle: {
      "width": "100%",
      "margin-left": "0px"
    },
    attrs: {
      "model": _vm.exportForm,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学年学期",
      "prop": "exXnxq"
    }
  }, [_c('el-select', {
    staticClass: "input-full",
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.exportForm.exXnxq),
      callback: function($$v) {
        _vm.$set(_vm.exportForm, "exXnxq", $$v)
      },
      expression: "exportForm.exXnxq"
    }
  }, _vm._l((_vm.xnxqInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "系部名称",
      "prop": "exXbmc"
    }
  }, [_c('el-select', {
    staticClass: "input-full",
    attrs: {
      "placeholder": "全部",
      "multiple": _vm.multiple,
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.initClassInfo($event, 'dept')
      }
    },
    model: {
      value: (_vm.exportForm.exXbmc),
      callback: function($$v) {
        _vm.$set(_vm.exportForm, "exXbmc", $$v)
      },
      expression: "exportForm.exXbmc"
    }
  }, _vm._l((_vm.deptInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "exZymc"
    }
  }, [_c('el-select', {
    staticClass: "input-full",
    attrs: {
      "placeholder": "全部",
      "multiple": _vm.multiple,
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.initClassInfo($event)
      }
    },
    model: {
      value: (_vm.exportForm.exZymc),
      callback: function($$v) {
        _vm.$set(_vm.exportForm, "exZymc", $$v)
      },
      expression: "exportForm.exZymc"
    }
  }, _vm._l((_vm.majorInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年级名称",
      "prop": "exNjmc"
    }
  }, [_c('el-select', {
    staticClass: "input-full",
    attrs: {
      "placeholder": "全部",
      "multiple": _vm.multiple,
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.initClassInfo($event)
      }
    },
    model: {
      value: (_vm.exportForm.exNjmc),
      callback: function($$v) {
        _vm.$set(_vm.exportForm, "exNjmc", $$v)
      },
      expression: "exportForm.exNjmc"
    }
  }, _vm._l((_vm.gradeInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班级名称",
      "prop": "exBjmc"
    }
  }, [_c('el-select', {
    staticClass: "input-full",
    attrs: {
      "placeholder": "全部",
      "multiple": _vm.multiple,
      "clearable": ""
    },
    model: {
      value: (_vm.exportForm.exBjmc),
      callback: function($$v) {
        _vm.$set(_vm.exportForm, "exBjmc", $$v)
      },
      expression: "exportForm.exBjmc"
    }
  }, _vm._l((_vm.classInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.type == 'export') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.checkResult
    }
  }, [_vm._v("导 出")]) : _vm._e(), _vm._v(" "), (_vm.type == 'remind') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.submitRemind
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "warnSetDialog",
    attrs: {
      "title": '学业预警设置',
      "width": "50%",
      "top": "14vh",
      "visible": _vm.warnSetDialogVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.warnSetDialogVisible = $event
      },
      "closed": _vm.closeWarnSetDialog
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-select', {
    staticStyle: {
      "width": "210px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "系部名称",
      "clearable": ""
    },
    on: {
      "change": _vm.changeDeptSet
    },
    model: {
      value: (_vm.warnSetForm.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.warnSetForm, "deptCode", $$v)
      },
      expression: "warnSetForm.deptCode"
    }
  }, _vm._l((_vm.deptWarnInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "210px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "专业名称",
      "clearable": ""
    },
    model: {
      value: (_vm.warnSetForm.majorCode),
      callback: function($$v) {
        _vm.$set(_vm.warnSetForm, "majorCode", $$v)
      },
      expression: "warnSetForm.majorCode"
    }
  }, _vm._l((_vm.majorWarnInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.queryWarnSet
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.warnSetReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.editWarnSet
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v(" 编辑")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.editWarnSet_multi
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v(" 批量编辑")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "warnSetTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.warnSetData,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": _vm.warnSetTableHeight
    },
    on: {
      "curplus-outlinerent-change": _vm.warnSetCurrentChange,
      "row-click": _vm.rowClick_warnSet
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage_warnSet - 1) * _vm.limit_warnSet + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "系部名称",
      "prop": "deptName",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "专业名称",
      "prop": "majorName",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "专业代码",
      "prop": "majorCode",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "不合格科目占比(%)",
      "prop": "bhgkmzb",
      "align": "center",
      "min-width": "12%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "不合格学分占比(%)",
      "prop": "bhgxfzb",
      "align": "center",
      "min-width": "12%"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage_warnSet,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.limit_warnSet,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalWarnSet
    },
    on: {
      "size-change": _vm.warnSetSizeChange,
      "current-change": _vm.warnSetPageChange,
      "update:currentPage": function($event) {
        _vm.currentPage_warnSet = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage_warnSet = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "editWarnSetDialog",
    attrs: {
      "title": '学业预警占比设置',
      "width": "40%",
      "top": "0",
      "visible": _vm.editWarnSetDialogVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.editWarnSetDialogVisible = $event
      },
      "closed": _vm.closeEditWarnSetDialogDialog
    }
  }, [_c('el-form', {
    ref: "editSetForm",
    staticClass: "small-space",
    staticStyle: {
      "width": "100%",
      "margin-left": "0px"
    },
    attrs: {
      "model": _vm.editSetForm,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "系部名称",
      "prop": "deptName"
    }
  }, [(_vm.editSetForm.editSetType == 'single') ? _c('div', [_vm._v(_vm._s(_vm.editSetForm.deptName))]) : _vm._e(), _vm._v(" "), (_vm.editSetForm.editSetType == 'multiple') ? _c('div', [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "系部名称",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "change": _vm.changeDeptEdit
    },
    model: {
      value: (_vm.editSetForm.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.editSetForm, "deptCode", $$v)
      },
      expression: "editSetForm.deptCode"
    }
  }, _vm._l((_vm.deptWarnSetInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "majorName"
    }
  }, [(_vm.editSetForm.editSetType == 'single') ? _c('div', [_vm._v(_vm._s(_vm.editSetForm.majorName))]) : _vm._e(), _vm._v(" "), (_vm.editSetForm.editSetType == 'multiple') ? _c('div', [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "专业名称",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.editSetForm.majorCode),
      callback: function($$v) {
        _vm.$set(_vm.editSetForm, "majorCode", $$v)
      },
      expression: "editSetForm.majorCode"
    }
  }, _vm._l((_vm.majorWarnSetInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "不合格科目占比",
      "prop": "bhgkmzb"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "precision": 0,
      "step": 1,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.editSetForm.bhgkmzb),
      callback: function($$v) {
        _vm.$set(_vm.editSetForm, "bhgkmzb", $$v)
      },
      expression: "editSetForm.bhgkmzb"
    }
  }), _vm._v(" %\n                ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "不合格学分占比",
      "prop": "bhgxfzb"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "precision": 0,
      "step": 1,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.editSetForm.bhgxfzb),
      callback: function($$v) {
        _vm.$set(_vm.editSetForm, "bhgxfzb", $$v)
      },
      expression: "editSetForm.bhgxfzb"
    }
  }), _vm._v(" %\n                ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.saveWarnSet
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeEditWarnSetDialogDialog
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbe33276"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/scoreManage/academicWarning.vue
// module id = 1902
// module chunks = 502